export default "//static.tradera.net/touchweb/static/output/images/category-tickets-travel.77048480.svg";